export default __webpack_public_path__ + "static/media/REAL CPI ASSET STIKER-08.644248c5.png";